import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useWishlist } from '../../hooks/useWishlist';
import Button from '../common/Button';
import { HeartIcon } from '../icons/Icons';
import { theme } from '../../config/theme';

const WishlistButton = ({ productId, variant = 'icon', size = 'md', showText = false }) => {
  const navigate = useNavigate();
  const { isAuthenticated, isCustomer } = useAuth();
  const { isInWishlist, toggleWishlist, loading } = useWishlist();
  const inWishlist = isInWishlist(productId);
  const [isUpdating, setIsUpdating] = useState(false);

  const handleClick = async (e) => {
    e.stopPropagation();
    
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }

    if (!isCustomer) return;

    setIsUpdating(true);
    try {
      await toggleWishlist(productId, inWishlist);
    } finally {
      setIsUpdating(false);
    }
  };

  if (variant === 'icon') {
    const iconButtonStyles = {
      width: size === 'sm' ? '32px' : size === 'lg' ? '48px' : '40px',
      height: size === 'sm' ? '32px' : size === 'lg' ? '48px' : '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: `2px solid ${inWishlist ? theme.colors.error : theme.colors.gray[300]}`,
      borderRadius: theme.borderRadius.full,
      backgroundColor: inWishlist ? `${theme.colors.error}10` : theme.colors.white,
      cursor: isUpdating ? 'not-allowed' : 'pointer',
      transition: theme.transitions.base,
      opacity: isUpdating ? 0.6 : 1,
    };

    return (
      <button
        onClick={handleClick}
        disabled={isUpdating}
        style={iconButtonStyles}
        onMouseEnter={(e) => {
          if (!isUpdating) {
            e.currentTarget.style.transform = 'scale(1.1)';
          }
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
        }}
        aria-label={inWishlist ? 'Remove from wishlist' : 'Add to wishlist'}
      >
        <HeartIcon 
          size={size === 'sm' ? 16 : size === 'lg' ? 24 : 20} 
          fill={inWishlist} 
          color={inWishlist ? theme.colors.error : theme.colors.gray[400]}
        />
      </button>
    );
  }

  return (
    <Button
      variant={inWishlist ? 'primary' : 'outline'}
      size={size}
      onClick={handleClick}
      disabled={isUpdating}
      loading={isUpdating}
    >
      <HeartIcon size={18} fill={inWishlist} />
      {showText && (inWishlist ? 'In Wishlist' : 'Add to Wishlist')}
    </Button>
  );
};

export default WishlistButton;